import React, { createContext, useContext, type ReactNode } from 'react';
import { useLocale, type UseLocaleResult } from '../hooks/useLocale';

const LocaleContext = createContext<UseLocaleResult | null>(null);

export function LocaleProvider({ children }: { children: ReactNode }) {
  const locale = useLocale();
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}

export function useAppLocale(): UseLocaleResult {
  const ctx = useContext(LocaleContext);
  if (!ctx) {
    throw new Error('useAppLocale must be used within LocaleProvider');
  }
  return ctx;
}
